export { AnatomyDiagram } from "./AnatomyDiagram";
